import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Plans,
  DeletePlans,
  CreatePlans,
  UpdatePlans,
} from '../../../store/actions';

/**
 * plans is responsible for injecting the methods about store of plans.
 *
 * @return
 *  plans: Array of plans.
 *  getPlans: () => Void
 *  createPlans: () => void
 *  updatePlans: () => void
 *  deletePlans: () => void
 */
export const PlansInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getPlans = useCallback((id) => {
    dispatch(Plans(id));
  }, []);

  /**
   * @return Void
   */
  const deletePlans = (id) => {
    dispatch(DeletePlans(id));
  };

  const createPlans = (values) => {
    dispatch(CreatePlans(values));
  };

  const updatePlans = (id, values) => {
    dispatch(UpdatePlans(id, values));
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * plans: object
   */
  const { error, loading, plans, success } = useSelector((state) => ({
    error: state.Plans.error,
    loading: state.Plans.loading,
    plans: state.Plans.plans,
    success: state.Plans.success,
  }));

  return {
    createPlans,
    updatePlans,
    getPlans,
    deletePlans,
    error,
    loading,
    plans,
    success,
  };
};
